import { all, call, put, select, take } from 'redux-saga/effects';

import api from 'api';
import { IPersonalPlanResponse } from 'api/components/PersonalPlan/types';

import { notifyError } from 'store/notifications/actions';
import {
    finalizeSetupRequest,
    generatePlanRequest,
    getCurrentPlanError,
    getCurrentPlanSuccess,
    setCurrentPlanCompletion,
} from 'store/personalPlan/actions';
import { waitForGetUserPersonalisation } from 'store/user/sagas/helpers';
import { selectCurrentUser } from 'store/user/selectors';
import { UserStore } from 'store/user/types';

import { addCompletenessToWorkouts } from 'helpers/personalPlan';
import { isWholePlanCompleted } from 'helpers/workout';

import { FINALIZE_SETUP_FINISHED } from '../actionTypes';

import { getWorkout } from './getWorkout';

export function* getCurrentPlan() {
    const { is_plan_generated }: UserStore = yield select(selectCurrentUser);

    if (!is_plan_generated) {
        yield put(finalizeSetupRequest());
        yield take(FINALIZE_SETUP_FINISHED);
    }

    try {
        const [{ id, current_day, days, yoga_type, plan_type, instructor }]: [IPersonalPlanResponse] = yield all([
            call(api.personalPlan.getCurrentPersonalPlan),
            call(waitForGetUserPersonalisation),
        ]);

        const workouts = addCompletenessToWorkouts({ days, currentDay: current_day });

        yield put(
            getCurrentPlanSuccess({
                id,
                current_day,
                days: workouts,
                yoga_type,
                plan_type,
                instructor,
            })
        );

        if (isWholePlanCompleted(workouts)) yield put(setCurrentPlanCompletion(true));

        yield call(getWorkout);
    } catch (error: any) {
        if (error.response?.status === 404) {
            yield put(generatePlanRequest());
        } else {
            yield put(getCurrentPlanError());
            yield put(notifyError({ message: 'basics.appError' }));
        }
    }
}
